<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <div class="element">
          <div class="search-box-container">
            <div class="nav" style="border-radius: 8px 8px 0 0">
              <h1>
                {{ projectSummary }}
                <span v-if="!listLoading && !listError">({{ projectCount }})</span>
              </h1>
              <select class="form-select" @change="selectNewStatus($event)" :disabled="listLoading">
                <option value="">Todos</option>
                <option value="1">Em análise</option>
                <option value="2">Ativos</option>
                <option value="4">Fechados</option>
                <option value="3">Desativados</option>
              </select>
            </div>
          </div>
          <div class="project-list">
            <div class="post_project post_project-active" style="padding: 20px; height: auto"
              :class="{ nopro: projects && projects.length === 0 }">
              <div class="loading_container" v-if="listLoading" style="height: 200px">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
              <div v-else-if="listError" class="create-project">
                <div class="card">
                  <div class="card-body">
                    <h2 class="text-danger">Erro</h2>
                    <p class="text-danger">
                      Ocorreu um erro ao atualizar a lista de projetos.<br />
                      Por favor, tente novamente.
                    </p>
                  </div>
                </div>
              </div>
              <div class="create-project" v-else-if="!projects || projects.length === 0">
                <div class="card">
                  <img src="assets/img/project.png" alt="" />
                  <div class="card-body">
                    <h2>Nenhum projeto encontrado</h2>
                  </div>
                </div>
              </div>
              <div class="active-project" style="padding: 0" v-else>
                <a class="card" style="position: static" :href="'/projeto/' + project.id" v-for="project in projects"
                  :key="project.id">
                  <div class="name">
                    <p>
                      Título <br />
                      <span>{{project.title}}</span>
                    </p>
                  </div>
                  <div class="date">
                    <p>
                     Data de registro <br />
                      <span>{{
                        formatTimestamp(project.registration_timestamp)
                      }}</span>
                    </p>
                  </div>
                  <div class="count">
                    <p>
                      Propostas <br />
                      <span>{{ project.total_proposals }}</span>
                    </p>
                  </div>
                  <div class="status">
                    <p>
                      Status <br /> 
                      <span :class="getTextStatusClass(project.status)">
                        {{ formatProjectStatus(project.status) }}</span>
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AdminManager from "../../../js/services/admin.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", "ProjectListPage");
    this.loadProjects();
  },

  data() {
    return {
      projects: null,
      listLoading: false,
      listError: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },

    projectCount() {
      if (this.projects) {
        return this.projects.length;
      }
      return 0;
    },
    projectSummary() {
      return "Projetos";
    },
  },

  methods: {
    async loadProjects() {
      this.$store.commit("setLoading", true);
      try {
        let response = await AdminManager.getProjects();
        let profile = response.profile;
        this.projects = response.projects;
        this.$store.commit("setActiveUser", profile);
        this.$store.commit("setLoading", false);
      } catch (error) {
        this.handleAPIError(error, "projetos");
      }
    },

    async selectNewStatus(event) {
      let selectedStatus = event.target.value;
      this.listLoading = true;
      this.listError = null;
      try {
        let response = await AdminManager.getProjects(selectedStatus);
        this.projects = response.projects;
      } catch (err) {
        console.log(err);
        this.listError = err;
      } finally {
        this.listLoading = false;
      }
    },

    showProject(project) {
      window.open("/projeto/" + project.id);
    },
  },
};
</script>
